import { useEffect, useRef } from "react";

export default function ReelVideo({ src, poster, caption, testid, aspect = "aspect-[9/16]" }) {
  const ref = useRef(null);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    v.muted = true;
    const tryPlay = () => v.play().catch(() => {});
    if (v.readyState >= 2) tryPlay();
    v.addEventListener("loadeddata", tryPlay);
    v.addEventListener("canplay", tryPlay);
    return () => {
      v.removeEventListener("loadeddata", tryPlay);
      v.removeEventListener("canplay", tryPlay);
    };
  }, []);

  return (
    <figure className="relative" data-testid={testid}>
      <div className={`relative overflow-hidden rounded-[1.75rem] border border-line shadow-lift bg-ink ${aspect}`}>
        <video
          ref={ref}
          poster={poster}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={src.replace(".mp4", ".webm")} type="video/webm" />
          <source src={src} type="video/mp4" />
        </video>
        <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-ink/60 text-ivory text-[0.62rem] font-semibold uppercase tracking-[0.14em] px-3 py-1.5 backdrop-blur">
          <span className="w-1.5 h-1.5 rounded-full bg-red-400 animate-pulse" />
          Video
        </span>
      </div>
      {caption && (
        <figcaption className="mt-3 text-center text-xs text-mutedc leading-relaxed">{caption}</figcaption>
      )}
    </figure>
  );
}